import { scrollToElement } from './utils.js'

let $forms = Array.from(document.querySelectorAll('.js-validate'))

$forms.forEach(init)

function init ($form) {
  $form.setAttribute('novalidate', '')

  let $fields = Array.from($form.elements).filter(
    $field => ['BUTTON'].indexOf($field.nodeName) === -1
  )

  $form.addEventListener('submit', e => {
    let valid = true
    removeErrorMessages(e.target)

    $fields.forEach(($field, i) => {
      let $container = $field.closest('.js-field')
      if ($field.required && $field.value.trim() === '') {
        $container.classList.add('is-invalid')
        insertErrorMessage($container, 'Please fill out this field.')
        if (valid === true) {
          // first error
          scrollToElement($container)
        }
        valid = false
      } else if ($container) {
        $container.classList.remove('is-invalid')
      }
    })

    if (!valid) {
      e.preventDefault()
      e.stopImmediatePropagation()
    }
  })
}

function createErrorMessage (msg) {
  let $msg = document.createElement('p')
  $msg.className = 'error text-red text-sm mt-2'
  $msg.textContent = `* ${msg}`
  return $msg
}

function insertErrorMessage ($container, msg) {
  $container.appendChild(createErrorMessage(msg))
}

function removeErrorMessages ($form) {
  Array.from($form.querySelectorAll('.error')).forEach($x => {
    $x.parentNode.removeChild($x)
  })
}



// WEBPACK FOOTER //
// ./src/js/_validate.js